import { createContext } from 'react';
import { createHubStore } from '../../../util/hubs/hubStore';
import { workflowRpcServer } from '../../../features/workflow/hub/workflowRpcServer';
import { workflowDataType } from '../../../features/workflow/types';

export type WorkflowStoreType = ReturnType<typeof createHubStore<workflowRpcServer, workflowDataType>>;
export const WorkflowContext = createContext<WorkflowStoreType | null>(null);
